import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import SydSelect from '../../../../../commonDesign/SydSelect'
import { FREQUENCIES } from './frequencyPreference'

// Compact select for the trend tool's frequency override. The tool
// registers it into the panel toolbar's actions slot alongside the
// ChartTypeToggle. Defaults are handled by the preference module.
//
// `Automatic` is intentionally the first option so it reads as the
// recommended default. The resolved frequency (whatever Orion picked)
// surfaces in the panel subjectLine -- the picker doesn't try to
// display it.

export default function FrequencyPicker ({ value, onChange }) {
  const options = useMemo(
    () => FREQUENCIES.map(v => ({ value: v, label: v })),
    []
  )

  return (
    <SydSelect
      options={options}
      value={value || 'Automatic'}
      onChange={(e) => onChange(e.target.value)}
      size='xs'
      minWidth='110px'
    />
  )
}

FrequencyPicker.propTypes = {
  value: PropTypes.oneOf(FREQUENCIES),
  onChange: PropTypes.func.isRequired
}
